// services/ant-design-pro/api.ts

import { request } from '@umijs/max';

declare global {
  interface Window {
    SERVER_URL: string;
  }
}

// 从 window.SERVER_URL 获取服务器地址，如果未设置则使用默认值
// const server_url = window.SERVER_URL || 'https://001code-pre-server.sciencexyz.com';
const server_url = window.SERVER_URL || 'http://localhost:8000';
console.log('API Server URL:', server_url); // 添加调试日志

/** 获取当前的用户 POST /api/currentUser */
export async function currentUser(player_id: number, accessToken: string, options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    data: API.CurrentUser;
  }>(`${server_url}/api/currentUser/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
    data: {
      player_id,
    },
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${server_url}/api/login/outLogin/`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>(`${server_url}/api/login/account/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 POST /api/rule */
export async function rule(
  data: {
    /** 当前的页码 */
    current: number;
    /** 页面的容量 */
    pageSize: number;
    [key: string]: any;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>(`${server_url}/api/getMyUserInfo/`, {
    method: 'POST',
    data: {
      ...data, // 包含 current 和 pageSize
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function batchEditUsers(options?: { [key: string]: any }) {

  return request<{
    success: boolean;
    message?: string;
    data?: API.RuleListItem;
  }>(`${server_url}/api/batchEditUsers/`, {
    method: 'POST',
    data: {
      method: 'update',
      
      ...(options || {}),
    },
  });
}


/** 新建规则 POST /api/rule */
export async function editUser(options?: { [key: string]: any }) {
  return request<API.RuleListItem>(`${server_url}/api/editUser/`, {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${server_url}/api/rule`, {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

export async function removeTeacher(
  body: { user_id?: number; user_ids?: number[] },
  options?: { [key: string]: any },
) {
  return request<{
    success?: boolean;
    message?: string;
    data?: Record<string, any>;
  }>(`${server_url}/api/remove_teacher/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function handoverTeacherClasses(
  params: {
    from_user_id: number;
    to_user_id: number;
    class_ids?: number[];
    class_names?: string[];
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message?: string;
    data?: Record<string, any>;
  }>(`${server_url}/api/handover_teacher_classes/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
    ...(options || {}),
  });
}

export async function getClassStudentsScoreStats(
  body: {
    class_id?: number;
    gamemode?: number;
    students: { id: number; username: string; full_name: string }[];
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message?: string;
    data?: any;
  }>(`${server_url}/api/get_class_students_score_stats/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取账号统计数据 POST /api/getAccountCounts */
export async function getAccountCounts(options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    data: {
      trainingPlatformAccounts: number;
      product2Accounts: number;
      product3Accounts: number;
      ai_points?: number;
      ai_quota?: number;
    };
  }>(`${server_url}/api/getAccountCounts/`, {
    method: 'POST',
    // 如果后端需要发送特定的数据，请在此处添加
    data: {},
    ...(options || {}),
  });
}

/** 获取激活码列表 POST /api/getActivationCodes */
export async function getActivationCodes(
  params: {
    current?: number;
    pageSize?: number;
    searchText?: string;
    filters?: Record<string, any>;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    data: {
      list: [];
      total: number;
    };
  }>(`${server_url}/api/getActivationCodes/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 生成激活码 POST /api/generateActivationCodes */
export async function generateActivationCodes(
  body: { count: number; activationType: string; remark?: string },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    data: [];
  }>(`${server_url}/api/generateActivationCodes/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建新班级 POST /api/create_class/ */
export async function createClass(
  body: { name: string, grade?: string },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data?: {
      class_id: number;
      name: string;
      created_at: string;
      grade: string;
    };
  }>(`${server_url}/api/create_class/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function updateClass(
  body: { class_id: number; name: string },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message?: string;
    data?: Record<string, any>;
  }>(`${server_url}/api/update_class/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除班级 POST /api/delete_class/ */
export async function deleteClass(
  body: { class_id: number },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message?: string;
  }>(`${server_url}/api/delete_class/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取我的班级列表 POST /api/get_my_classes */
export async function getMyClasses(options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    data: {
      class_id: number;
      name: string;
      created_at: string;
      student_count: number;
    }[];
  }>(`${server_url}/api/get_my_classes/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {},  // 添加空的 data 对象，因为是 POST 请求
    ...(options || {}),
  });
}

/** 获取用户基本信息 POST /api/get_user_basic_info */
export async function getUserBasicInfo(options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    message?: string;
    data: {
      full_name: string;
      school_name: string;
      institution_id: number;
      province_id: number;
      city_id: number;
      district_id: number;
      managerlv: number;
      ai_points?: number;
    };
  }>(`${server_url}/api/get_user_basic_info/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {},
    ...(options || {}),
  });
}

/** 添加学生到班级 POST /api/add_student_to_class */
export async function updateClassStudents(
  body: { 
    class_id: number;
    username: number;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data?: {
      class_id: number;
      student_count: number;
    };
  }>(`${server_url}/api/add_student_to_class/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取班级详情 POST /api/get_class_detail */
export async function getClassDetail(
  body: { 
    class_id: number;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message?: string;
    data?: {
      class_id: number;
      name: string;
      created_at: string;
      grade: string;
      creator: {
        id: number;
        username: string;
        full_name: string;
      };
      students: {
        id: number;
        username: string;
        full_name: string;
        email: string;
        phone_number: string;
      }[];
    };
  }>(`${server_url}/api/get_class_detail/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取用户配置 POST /api/get_user_config */
export async function getUserConfig(
  body: { 
    user_id: number;
  },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    success: boolean;
    message: string;
    data?: {
      allow_download: boolean;
      enable_screen_block: boolean;
      enable_ai_screen_block: boolean;
      show_course_folder: boolean | number;
      close_ai?: number;
    };
  }>(`${server_url}/api/get_user_config/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询用户关卡解锁 POST /api/get_user_unlock_snapshot/ */
export async function getUserUnlockSnapshot(
  body: { user_id: number },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message?: string;
    data?: {
      snapshots: Array<{ gamemode: number; max_gamelv: number }>;
    };
  }>(`${server_url}/api/get_user_unlock_snapshot/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 更新或新增用户关卡解锁 POST /api/update_user_unlock_snapshot/ */
export async function updateUserUnlockSnapshot(
  body: { user_id: number; gamemode: number; max_gamelv: number },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message?: string;
    data?: {
      user_id: number;
      gamemode: number;
      max_gamelv: number;
      created?: boolean;
    };
  }>(`${server_url}/api/update_user_unlock_snapshot/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 更新用户配置 POST /api/update_user_config */
export async function updateUserConfig(
  body: { 
    user_id: number;
    config: {
      allow_download?: boolean;
      enable_screen_block?: boolean;
      enable_ai_screen_block?: boolean;
      show_course_folder?: boolean | number;
      close_ai?: number;
    };
  },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    success: boolean;
    message: string;
    data?: {
      allow_download: boolean;
      enable_screen_block: boolean;
      enable_ai_screen_block: boolean;
      show_course_folder: boolean | number;
      close_ai?: number;
    };
  }>(`${server_url}/api/update_user_config/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 批量添加或移除班级学生 POST /api/batch_manage_class_students */
export async function batchManageClassStudents(
  body: {
    class_id: number;
    action: 'add' | 'remove';
    usernames: string[];
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data?: {
      success_count: number;
      failed: { username: string; message: string }[];
      student_count: number;
    };
  }>(`${server_url}/api/batch_manage_class_students/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 从班级中移除学生 POST /api/remove_student_from_class */
export async function removeStudentFromClass(
  body: { 
    class_id: number;
    username: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data?: {
      class_id: number;
      username: string;
      student_name: string;
      student_count: number;
    };
  }>(`${server_url}/api/remove_student_from_class/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取学生游戏记录 POST /api/get_student_game_records */
export async function getStudentGameRecords(
  body: { 
    username: string;
    gamemode: number;
    current?: number;
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message?: string;
    data?: {
      studentname: string;
      studentid: string;
      gamelv: number;
      gameid: number;
      currentlv: number;
      createdAt: number;
      isCompleted: boolean;
      codenumber: number;
      targetcodenumber: number;
      stepnumber: number;
      targetstepnumber: number;
    }[];
    total?: number;
    current?: number;
    pageSize?: number;
  }>(`${server_url}/api/get_student_game_records/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 批量更新用户配置 POST /api/batch_update_user_config */
export async function batchUpdateUserConfig(
  body: { 
    configs: {
      user_id: number;
      config: {
        allow_download?: boolean;
        enable_screen_block?: boolean;
        enable_ai_screen_block?: boolean;
        show_course_folder?: boolean | number;
        close_ai?: number;
      };
    }[];
  },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    success: boolean;
    message: string;
    data?: {
      updated_count: number;
      results: {
        user_id: number;
        config: {
          allow_download: boolean;
          enable_screen_block: boolean;
          enable_ai_screen_block: boolean;
          show_course_folder: boolean | number;
          close_ai?: number;
        };
      }[];
    };
  }>(`${server_url}/api/batch_update_user_config/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取省份列表 GET /api/provinces */
export async function getProvinces() {
  return request<API.Province[]>(`${server_url}/api/provinces/`, {
    method: 'GET',
  });
}

/** 获取城市列表 GET /api/cities/:province_id */
export async function getCities(provinceId: number) {
  return request<API.City[]>(`${server_url}/api/cities/${provinceId}/`, {
    method: 'GET',
  });
}

/** 获取区县列表 GET /api/districts/:city_id */
export async function getDistricts(cityId: number) {
  return request<API.District[]>(`${server_url}/api/districts/${cityId}/`, {
    method: 'GET',
  });
}

/** 获取年级列表 GET /api/grades */
export async function getGrades(options?: { [key: string]: any }) {
  return request<API.GradeItem[]>(`${server_url}/api/grades/`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 批量创建学生账号 POST /api/batch-create-students */
export async function batchCreateStudents(
  body: API.BatchCreateStudentsParams,
  options?: { [key: string]: any },
) {
  return request<API.BatchCreateStudentsResult>(`${server_url}/api/batch-create-students/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 检查用户名是否可用 POST /api/check-usernames-availability */
export async function checkUsernamesAvailability(
  body: { 
    usernames: string[];
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message?: string;
    data?: {
      [key: string]: boolean;
    };
  }>(`${server_url}/api/check-usernames-availability/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 批量注册用户（流式响应） POST /api/batch_register_streaming */
export async function batchRegisterStreaming(
  body: { 
    users: API.BatchRegisterUserItem[];
    institution_id?: number;
  },
  onMessage: (message: any) => void,
  onError: (error: any) => void,
  onComplete: () => void,
) {
  try {
    const response = await fetch(`${server_url}/api/batch_register_streaming/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const reader = response.body?.getReader();
    if (!reader) {
      throw new Error('无法获取响应流');
    }

    const decoder = new TextDecoder();
    let buffer = '';

    const processStream = async () => {
      try {
        while (true) {
          const { done, value } = await reader.read();
          
          if (done) {
            // 处理缓冲区中剩余的数据
            if (buffer.trim()) {
              try {
                const message = JSON.parse(buffer.trim());
                onMessage(message);
              } catch (e) {
                console.error('解析JSON失败:', buffer);
              }
            }
            onComplete();
            break;
          }

          // 将新接收的数据添加到缓冲区
          buffer += decoder.decode(value, { stream: true });
          
          // 按行分割并处理完整的JSON对象
          const lines = buffer.split('\n');
          buffer = lines.pop() || ''; // 最后一行可能不完整，保留在缓冲区
          
          for (const line of lines) {
            if (line.trim()) {
              try {
                const message = JSON.parse(line.trim());
                onMessage(message);
              } catch (e) {
                console.error('解析JSON失败:', line);
              }
            }
          }
        }
      } catch (error) {
        onError(error);
      }
    };

    processStream();
  } catch (error) {
    onError(error);
  }
}

/** 批量将学生添加到班级（流式响应） POST /api/batch_add_students_to_class */
export async function batchAddStudentsToClass(
  body: { 
    class_id: number;
    usernames: string[];
    description?: string;
  },
  onMessage: (message: any) => void,
  onError: (error: any) => void,
  onComplete: () => void,
) {
  try {
    const payload = {
      ...body,
      usernames: (body.usernames || []).map((u) => String(u)),
    };
    const response = await fetch(`${server_url}/api/batch_add_students_to_class/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const reader = response.body?.getReader();
    if (!reader) {
      throw new Error('无法获取响应流');
    }

    const decoder = new TextDecoder();
    let buffer = '';

    const processStream = async () => {
      try {
        while (true) {
          const { done, value } = await reader.read();
          
          if (done) {
            // 处理缓冲区中剩余的数据
            if (buffer.trim()) {
              try {
                const message = JSON.parse(buffer.trim());
                onMessage(message);
              } catch (e) {
                console.error('解析JSON失败:', buffer);
              }
            }
            onComplete();
            break;
          }

          // 将新接收的数据添加到缓冲区
          buffer += decoder.decode(value, { stream: true });
          
          // 按行分割并处理完整的JSON对象
          const lines = buffer.split('\n');
          buffer = lines.pop() || ''; // 最后一行可能不完整，保留在缓冲区
          
          for (const line of lines) {
            if (line.trim()) {
              try {
                const message = JSON.parse(line.trim());
                onMessage(message);
              } catch (e) {
                console.error('解析JSON失败:', line);
              }
            }
          }
        }
      } catch (error) {
        onError(error);
      }
    };

    processStream();
  } catch (error) {
    onError(error);
  }
}

/** 查询比赛列表 POST /api/competition/query_competitions */
export async function queryCompetitions(
  params: {
    page?: number;
    page_size?: number;
    id?: number;
    name?: string;
    status?: string;
    competition_level_package_id?: number;
    creator_id?: number;
    competition_level?: string;
    province_id?: number;
    city_id?: number;
    district_id?: number;
    institution_id?: number;
    is_authorized?: boolean;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      total: number;
      page: number;
      page_size: number;
      competitions: API.CompetitionItem[];
    };
  }>(`${server_url}/api/competition/query_competitions/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 创建比赛 POST /api/competition/create_competition */
export async function createCompetition(
  data: API.CreateCompetitionParams,
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      id: number;
      name: string;
      status: string;
      created_at: string;
    };
  }>(`${server_url}/api/competition/create_competition/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/** 更新比赛 POST /api/competition/update_competition */
export async function updateCompetition(
  data: API.UpdateCompetitionParams,
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      id: number;
      name: string;
      status: string;
      updated_at: string;
    };
  }>(`${server_url}/api/competition/update_competition/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/** 创建关卡包 POST /api/competition/create_level_package */
export async function createLevelPackage(
  data: {
    name: string;
    level_ids: number[];
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      id: number;
      name: string;
      level_count: number;
      created_at: string;
    };
  }>(`${server_url}/api/competition/create_level_package/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/** 更新关卡包 POST /api/competition/update_level_package */
export async function updateLevelPackage(
  data: {
    id: number;
    name?: string;
    level_ids?: number[];
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      id: number;
      name: string;
      level_count: number;
      updated_at: string;
    };
  }>(`${server_url}/api/competition/update_level_package/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/** 查询关卡包列表 POST /api/competition/query_level_packages */
export async function queryLevelPackages(
  params: {
    page?: number;
    page_size?: number;
    id?: number;
    name?: string;
    creator_id?: number;
    created_after?: string;
    created_before?: string;
    gamemode?: number;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      total: number;
      page: number;
      page_size: number;
      level_packages: {
        id: number;
        name: string;
        level_count: number;
        levels: {
          id: number;
          gamelv: number;
          gameid: number;
          currentlv: number;
          gamemode: number;
          unity_game_number: number;
        }[];
        creator: {
          id: number;
          username: string;
        };
        created_at: string;
      }[];
    };
  }>(`${server_url}/api/competition/query_level_packages/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 查询关卡数据 POST /api/competition/query_level_data */
export async function queryLevelData(
  params: {
    page?: number;
    page_size?: number;
    gamemode?: number;
    gamelv?: number;
    gameid?: number;
    currentlv?: number;
    unity_game_number?: number;
    programming_knowledge?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      total: number;
      page: number;
      page_size: number;
      levels: {
        id: number;
        gamemode: number;
        gamelv: number;
        gameid: number;
        currentlv: number;
        stepTarget: number;
        blockTarget: number;
        unity_game_number: number;
        video_url: string;
        programming_knowledge: string;
      }[];
    };
  }>(`${server_url}/api/competition/query_level_data/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 批量创建关卡数据 POST /api/competition/batch_create_level_data */
export async function batchCreateLevelData(
  data: {
    levels: {
      gamemode: number;
      gamelv: number;
      gameid: number;
      currentlv: number;
      stepTarget: number;
      blockTarget: number;
      unity_game_number?: number;
      video_url?: string;
      programming_knowledge?: string;
    }[];
    skip_existing?: boolean;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      created_count: number;
      skipped_count: number;
      failed_count: number;
      failed_levels: {
        level: any;
        error: string;
      }[];
    };
  }>(`${server_url}/api/competition/batch_create_level_data/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/** 更新关卡数据 POST /api/competition/update_level_data */
export async function updateLevelData(
  data: {
    id: number;
    gamemode?: number;
    gamelv?: number;
    gameid?: number;
    currentlv?: number;
    stepTarget?: number;
    blockTarget?: number;
    unity_game_number?: number;
    video_url?: string;
    programming_knowledge?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      id: number;
      gamemode: number;
      gamelv: number;
      gameid: number;
      currentlv: number;
      stepTarget: number;
      blockTarget: number;
      unity_game_number: number;
      video_url: string;
      programming_knowledge: string;
    };
  }>(`${server_url}/api/competition/update_level_data/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/** 根据关键词搜索学校/机构 */
export async function searchInstitutions(keyword: string) {
  return request<API.Institution[]>(`${server_url}/api/institutions/search/${keyword}/`, {
    method: 'GET',
  });
}

/** 获取学校列表 POST /api/institutions/ */
export async function getInstitutionList(
  params: {
    page?: number;
    page_size?: number;
    name?: string;
    province_id?: number;
    city_id?: number;
    district_id?: number;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      total: number;
      page: number;
      page_size: number;
      institutions: API.InstitutionWithDistrict[];
    };
  }>(`${server_url}/api/institutions/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 根据区县ID获取学校列表 POST /api/institutions/by-district/ */
export async function getInstitutionByDistrict(
  params: {
    district_id: number;
    page?: number;
    page_size?: number;
    name?: string;
  },
  options?: { [key: string]: any },
) {
  console.log('调用getInstitutionByDistrict API，参数:', params);
  return request<{
    success: boolean;
    message: string;
    data: {
      total: number;
      page: number;
      page_size: number;
      district: API.District;
      institutions: API.InstitutionWithDistrict[];
    };
  }>(`${server_url}/api/institutions/by-district/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
    errorHandler: (error: any) => {
      console.error('获取学校列表失败:', error, '请求参数:', params);
      // 返回自定义错误信息
      return {
        success: false,
        message: `获取学校列表失败, 区县ID: ${params.district_id}`,
        data: null
      };
    }
  });
}

/** 获取未关联区县的学校列表 POST /api/institutions/without-district/ */
export async function getInstitutionsWithoutDistrict(
  params: {
    page?: number;
    page_size?: number;
    name?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      total: number;
      page: number;
      page_size: number;
      institutions: API.InstitutionWithDistrict[];
    };
  }>(`${server_url}/api/institutions/without-district/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 关联学校到区县 POST /api/institutions/link-to-district/ */
export async function linkInstitutionToDistrict(
  params: {
    institution_id: number;
    district_id: number | null;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      institution: API.InstitutionWithDistrict;
    };
  }>(`${server_url}/api/institutions/link-to-district/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 创建学校并关联到区县 POST /api/dealer/create-institution/ */
export async function createInstitution(
  params: {
    name: string;
    district_id: number;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      institution: API.InstitutionWithDistrict;
    };
  }>(`${server_url}/api/dealer/create-institution/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 批量关联学校到区县 POST /api/institutions/batch-link-to-district/ */
export async function batchLinkInstitutionsToDistrict(
  params: {
    institution_ids: number[];
    district_id: number | null;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      updated_count: number;
      institutions: API.InstitutionWithDistrict[];
    };
  }>(`${server_url}/api/institutions/batch-link-to-district/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 获取经销商列表 POST /api/dealer/get-dealer-list */
export async function getDealerList(params: API.DealerListParams) {
  return request<API.DealerListResult>(`${server_url}/api/dealer/get-dealer-list/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  });
}

/** 获取上级经销商列表 POST /api/dealer/get-superior-list */
export async function getSuperiorList(params: API.SuperiorListParams) {
  return request<API.SuperiorListResult>(`${server_url}/api/dealer/get-superior-list/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  });
}

/** 绑定管理员 POST /api/dealer/bind-manager */
export async function bindManager(params: API.BindManagerParams) {
  return request<API.ManagerActionResult>(`${server_url}/api/dealer/bind-manager/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  });
}

/** 修改管理员 POST /api/dealer/modify_manager */
export async function modifyManager(params: API.ModifyManagerParams) {
  return request<API.ManagerActionResult>(`${server_url}/api/dealer/modify_manager/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  });
}

/** 根据用户名获取用户基本信息 */
export async function getUserBasicInfoByUsername(params: { username: string }) {
  return request<API.UserBasicInfoResult>(`${server_url}/api/get_user_basic_info_by_username/`, {
    method: 'POST',
    data: params,
  });
}

/** 添加撤销管理员权限API */
export async function revokeManager(params: { target_user_id: number }) {
  return request<{
    success: boolean;
    message: string;
    data?: {
      target_user: {
        id: number;
        username: string;
        managerlv: number;
        managerlv_display: string;
      }
    };
  }>(`${server_url}/api/dealer/revoke_manager/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  });
}

/** 添加分配配额的API函数 */
export async function allocateQuota(params: {
  target_user_id: number;
  amount: number;
}) {
  return request(`${server_url}/api/dealer/allocate-quota/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  });
}

/** 指定账号自分配配额/灵丌AI配额/AI积分 GET|POST /api/dealer/self-allocate/ */
export async function getSelfAllocateProfile(options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    message?: string;
    data?: {
      id: number;
      username: string;
      full_name?: string;
      managerlv: number;
      activation_quota: number;
      ai_quota: number;
      ai_points: number;
    };
  }>(`${server_url}/api/dealer/self-allocate/`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function selfAllocate(params: {
  type: 'quota' | 'ai_quota' | 'ai_points';
  amount: number;
}) {
  return request<{
    success: boolean;
    message?: string;
    data?: {
      type: string;
      amount: number;
      activation_quota: number;
      ai_quota: number;
      ai_points: number;
      transaction_id?: number;
    };
  }>(`${server_url}/api/dealer/self-allocate/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  });
}

/** 分配灵丌AI配额 POST /api/dealer/allocate-ai-quota/ */
export async function allocateAiQuota(params: {
  target_user_id: number;
  amount: number;
}) {
  return request(`${server_url}/api/dealer/allocate-ai-quota/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  });
}

/** 关闭线上支付 POST /api/dealer/close-online-payment/ */
export async function closeOnlinePayment(params: {
  province_id?: number;
  city_id?: number;
  district_id?: number;
  institution_id?: number;
  product_types: Array<'course' | 'points' | 'membership'>;
  description?: string;
}) {
  return request(`${server_url}/api/dealer/close-online-payment/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  });
}

/** 查询区域已关闭的支付类型 POST /api/dealer/get-online-payment-exclusions/ */
export async function getOnlinePaymentExclusions(params: {
  province_id?: number;
  city_id?: number;
  district_id?: number;
  institution_id?: number;
}) {
  return request<{
    success: boolean;
    message?: string;
    data?: {
      region: Record<string, number | null>;
      product_types: Array<'course' | 'points' | 'membership'>;
    };
  }>(`${server_url}/api/dealer/get-online-payment-exclusions/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  });
}

/** 添加扣除配额的API函数 */
export async function deductQuota(params: {
  target_user_id: number;
  amount: number;
}) {
  return request(`${server_url}/api/dealer/deduct-quota/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  });
}

/** 分配AI积分的API函数 POST /api/dealer/allocate-ai-points/ */
export async function allocateAiPoints(
  params: {
    target_user_id?: number;
    user_id?: number;
    amount?: number;
    points?: number;
    [key: string]: any;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message?: string;
    data?: any;
  }>(`${server_url}/api/dealer/allocate-ai-points/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      target_user_id: params.target_user_id ?? params.user_id,
      user_id: params.user_id ?? params.target_user_id,
      amount: params.amount ?? params.points,
      points: params.points ?? params.amount,
      ...params,
    },
    ...(options || {}),
  });
}

/** 批量分配灵丌AI积分 POST /api/dealer/batch-allocate-ai-points/ */
export async function batchAllocateAiPoints(
  params: {
    user_ids: number[];
    amount?: number;
    points?: number;
    [key: string]: any;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message?: string;
    data?: {
      total?: number;
      success_count?: number;
      failed_count?: number;
      stopped?: boolean;
      stop_reason?: string;
      success_user_ids?: number[];
      failed_users?: { user_id: number; reason: string }[];
      allocated_points?: number;
      operator_ai_points?: number;
    };
  }>(`${server_url}/api/dealer/batch-allocate-ai-points/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      user_ids: params.user_ids,
      amount: params.amount ?? params.points,
      points: params.points ?? params.amount,
      ...params,
    },
    ...(options || {}),
  });
}

/** 查询课程开通 POST /api/ai-explorer/institution-course-permission/ */
export async function getInstitutionCoursePermission(
  params: {
    institution_id?: number;
    semester_id?: number;
    user_id?: number;
    user_ids?: number[];
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message?: string;
    data?: {
      institution_id: number | null;
      permissions?: API.InstitutionCoursePermissionItem[];
    };
  }>(`${server_url}/api/ai-explorer/institution-course-permission/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 开通/续期课程 POST /api/ai-explorer/activate-institution-course-permission/ */
export async function activateInstitutionCoursePermission(
  params: {
    institution_id?: number;
    semester_id?: number;
    semester_ids?: number[];
    duration_days?: number;
    user_count?: number;
    user_id?: number;
    user_ids?: number[];
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message?: string;
    data?: {
      institution_id?: number | null;
      permissions?: API.InstitutionCoursePermissionItem[];
    } & Partial<API.InstitutionCoursePermissionItem>;
  }>(`${server_url}/api/ai-explorer/activate-institution-course-permission/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 修改用户的试用关卡数量 POST /manager/update_trial_level_count/ */
export async function updateTrialLevelCount(
  params: {
    user_id: number;
    trial_level_count: number;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data?: {
      user_id: number;
      username: string;
      trial_level_count: number;
    };
  }>(`${server_url}/manager/update_trial_level_count/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 批量修改用户的试用关卡数量 POST /manager/batch_update_trial_level_count/ */
export async function batchUpdateTrialLevelCount(
  params: {
    user_ids: number[];
    trial_level_count: number;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data?: {
      total: number;
      success_count: number;
      failed_count: number;
      failed_users: {
        user_id: number;
        reason: string;
      }[];
    };
  }>(`${server_url}/manager/batch_update_trial_level_count/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 获取用户配额记录 POST /api/dealer/get-quota-records/ */
export async function getQuotaRecords(
  params: {
    user_id: number;
    page?: number;
    page_size?: number;
    operation_type?: 'all' | 'allocation' | 'consumption';
    start_date?: string;
    end_date?: string;
    reason_prefix?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data?: {
      total: number;
      page: number;
      page_size: number;
      consumption_sum?: number;
      records: {
        id: number;
        change_amount: number;
        created_at: string;
        operation_type: string;
        operation_type_display: string;
        reason: string;
        operated_by: {
          id: number;
          username: string;
          full_name: string;
        } | null;
      }[];
    };
  }>(`${server_url}/api/dealer/get-quota-records/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 获取用户灵丌AI积分记录 POST /api/dealer/get-ai-points-records/ */
export async function getAiPointsRecords(
  params: {
    user_id: number;
    page?: number;
    page_size?: number;
    operation_type?: 'all' | 'allocation' | 'consumption';
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data?: {
      total: number;
      page: number;
      page_size: number;
      records: {
        id: number;
        change_amount: number;
        created_at: string;
        operation_type: string;
        operation_type_display: string;
        reason: string;
        operated_by: {
          id: number;
          username: string;
          full_name: string;
        } | null;
      }[];
    };
  }>(`${server_url}/api/dealer/get-ai-points-records/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 获取比赛排行榜数据 POST /api/competition/get_competition_rank */
export async function getCompetitionRank(
  params: {
    competition_id: number;
    progress_type?: 'competition' | 'practice';
    codetype: number;
    page?: number;
    page_size?: number;
    skip_cache?: boolean;
    username?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      competition: {
        id: number;
        name: string;
        announcement?: string;
      };
      progress_type: string;
      codetype: number;
      total: number;
      page: number;
      page_size: number;
      leaderboard: Array<{
        username: string;
        full_name: string;
        institution: string;
        grade_name?: string;
        class_name?: string;
        user_group?: string; // 用户组别
        completed_count: number;
        total_block_count: number;
        total_step_count: number;
        total_duration: number;
        rank: number;
        codetype: number;
      }>;
    };
  }>(`${server_url}/api/competition/get_competition_rank/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 创建广告 POST /api/advertisement/create/ */
export async function createAdvertisement(
  data: {
    title: string;
    background_url: string;
    link: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data?: {
      id: number;
      title: string;
      background_url: string;
      link: string;
      created_at: string;
    };
  }>(`${server_url}/api/advertisement/create/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/** 审批广告 POST /api/advertisement/approve/ */
export async function approveAdvertisement(
  data: {
    advertisement_id: number;
    is_approved: boolean;
    is_active: boolean;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
  }>(`${server_url}/api/advertisement/approve/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/** 获取广告列表 POST /api/advertisement/get_list/ */
export async function getAdvertisements(
  params: {
    include_inactive?: boolean;
    only_mine?: boolean;
    page?: number;
    page_size?: number;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      total: number;
      page: number;
      page_size: number;
      advertisements: Array<{
        id: number;
        title: string;
        background_url: string;
        link: string;
        is_active: boolean;
        is_approved: boolean;
        created_at: string;
        updated_at: string;
        approval_date: string | null;
        creator: {
          id: number;
          username: string;
        } | null;
        approver: {
          id: number;
          username: string;
        } | null;
      }>;
    };
  }>(`${server_url}/api/advertisement/get_list/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 更新广告激活状态 POST /api/advertisement/update_advertisement_status/ */
export async function updateAdvertisementStatus(
  data: API.UpdateAdvertisementStatusParams,
  options?: { [key: string]: any },
) {
  return request<API.UpdateAdvertisementStatusResult>(`${server_url}/api/advertisement/update_advertisement_status/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/** 设置广告地域限制 POST /api/advertisement/set_location/ */
export async function setAdvertisementLocation(
  data: API.SetAdvertisementLocationParams,
  options?: { [key: string]: any },
) {
  return request<API.SetAdvertisementLocationResult>(`${server_url}/api/advertisement/set_location/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/** 设置广告投放方式 POST /api/advertisement/set_delivery_mode/ */
export async function setAdvertisementDeliveryMode(
  data: API.SetAdvertisementDeliveryModeParams,
  options?: { [key: string]: any },
) {
  return request<API.SetAdvertisementDeliveryModeResult>(`${server_url}/api/advertisement/set_delivery_mode/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

// 用户信息类型
export interface UserInfo {
  userID: number;
  id: number;
  userName: string;
  name: string;
  phoneNumber: string;
  province: string;
  city: string;
  district: string;
  school: string;
  classes?: string; // 新增：用户所在班级信息
  email_display?: string;
  activetion: number;
  remainingTime?: number;
  is_staff?: number;
  key: string;
  trial_level_count?: number;
  registration_time?: string;
  registration_timestamp?: number;
  ai_points?: number;
}

// 获取用户信息参数
export interface GetMyUserInfoParams {
  current?: number;
  pageSize?: number;
  userName?: string;
  name?: string;
  phoneNumber?: string;
  province?: string;
  city?: string;
  district?: string;
  school?: string;
  classes?: string; // 新增：按班级搜索
  is_staff?: number;
  activetion?: string;
  remainingTime?: number;
}

// 获取用户信息响应
export interface GetMyUserInfoResponse {
  success: boolean;
  message?: string;
  data: UserInfo[];
  total: number;
  pageSize: number;
  current: number;
}

// 分配广告给用户参数
export interface AssignAdvertisementToUserParams {
  advertisement_ids: number[];
  user_ids?: number[];
  province_id?: number;
  city_id?: number;
  district_id?: number;
  institution_id?: number;
  display_order?: number;
  is_active?: boolean;
}

// 分配广告给用户响应
export interface AssignAdvertisementToUserResponse {
  success: boolean;
  message?: string;
  data?: {
    success_count: number;
    skipped_count: number;
    failed_count: number;
    user_count: number;
    advertisement_count: number;
    filter_conditions: string[];
    total_operations: number;
    processing_time_seconds: number;
    batches_processed: number;
  };
}

/** 获取用户信息 POST /api/getMyUserInfo/ */
export async function getMyUserInfo(params: GetMyUserInfoParams, options?: { [key: string]: any }) {
  return request<GetMyUserInfoResponse>(`${server_url}/api/getMyUserInfo/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 班级选人：与 getMyUserInfo 相同，老师（is_staff）可查看本校用户 POST /api/getTeacherSchoolUserInfo/ */
export async function getTeacherSchoolUserInfo(params: GetMyUserInfoParams, options?: { [key: string]: any }) {
  return request<GetMyUserInfoResponse>(`${server_url}/api/getTeacherSchoolUserInfo/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 分配广告给用户 POST /api/advertisement/assign_to_user/ */
export async function assignAdvertisementToUser(params: AssignAdvertisementToUserParams, options?: { [key: string]: any }) {
  return request<AssignAdvertisementToUserResponse>(`${server_url}/api/advertisement/assign_to_user/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

// 获取广告分配的用户列表参数
export interface GetAdvertisementUsersParams {
  advertisement_id: number;
  include_inactive?: boolean;
  max_users?: number;
  search_username?: string;
  province_id?: number;
  city_id?: number;
  district_id?: number;
  institution_id?: number;
}

// 获取广告分配的用户列表响应
export interface GetAdvertisementUsersResponse {
  success: boolean;
  message?: string;
  data?: {
    total: number;
    max_users: number;
    returned_count: number;
    advertisement: {
      id: number;
      title: string;
      background_url: string;
      link: string;
      is_active: boolean;
      is_approved: boolean;
    };
    users: Array<{
      user_id: number;
      username: string;
      email: string;
      mobile: string;
      province_id: number;
      city_id: number;
      district_id: number;
      institution_id: number;
      display_order: number;
      is_active: boolean;
      user_advertisement_id: number;
      created_at: string;
    }>;
  };
}

/** 获取广告分配的用户列表 POST /api/advertisement/get_users/ */
export async function getAdvertisementUsers(params: GetAdvertisementUsersParams, options?: { [key: string]: any }) {
  return request<GetAdvertisementUsersResponse>(`${server_url}/api/advertisement/get_users/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 根据学校ID获取班级和年级信息 POST /api/get_institution_classes/ */
export async function getInstitutionClasses(
  body: {
    institution_id: number;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      institution_name: string;
      grades: {
        grade_name: string;
        classes: {
          id: number;
          name: string;
          creator: string;
          creator_id: number;
          student_count: number;
        }[];
      }[];
    };
  }>(`${server_url}/api/get_institution_classes/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 批量添加用户到比赛（流式接口，使用fetch原生API实现） */
export async function batchAddCompetitionParticipants(
  params: {
    competition_id: number;
    user_ids?: number[];
    usernames?: string[];
    username_codetypes?: Array<{ username: string; codetype: number }>;
    username_user_groups?: Array<{ username: string; user_group: string }>;
    province_id?: number;
    city_id?: number;
    district_id?: number;
    institution_id?: number;
    grade?: string;
    class_name?: string;
    codetype?: number;
    user_group?: string;
    batch_size?: number;
  },
  onMessage: (message: any) => void,
  onError: (error: any) => void,
  onComplete: () => void,
) {
  try {
    const fetchUrl = `${server_url}/api/competition/batch_add_participants/`;
    const response = await fetch(fetchUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(params),
    });

    if (!response.ok) {
      throw new Error(`HTTP错误! 状态码: ${response.status}`);
    }

    const reader = response.body?.getReader();
    if (!reader) {
      throw new Error('无法读取响应流');
    }

    let receivedText = '';
    let lastLineEnd = 0;

    const processStream = async () => {
      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          onComplete();
          break;
        }

        // 解码响应数据
        const chunk = new TextDecoder().decode(value);
        receivedText += chunk;

        // 寻找完整的JSON行
        while (true) {
          const lineEnd = receivedText.indexOf('\n', lastLineEnd);
          if (lineEnd === -1) break;

          const line = receivedText.substring(lastLineEnd, lineEnd).trim();
          lastLineEnd = lineEnd + 1;

          if (line) {
            try {
              const data = JSON.parse(line);
              onMessage(data);
            } catch (error) {
              console.error('解析JSON响应失败', error, line);
            }
          }
        }
      }
    };

    processStream().catch(onError);
  } catch (error) {
    onError(error);
  }
}

/** 复制游戏记录 POST /api/copy_game_records/ */
export async function copyGameRecords(
  params: {
    source_user: {
      id?: number;
      username?: string;
    };
    target_user: {
      id?: number;
      username?: string;
    };
    filters?: {
      gamemodes?: number[];
      gamelvs?: number[];
      gameids?: number[];
      currentlvs?: number[];
    };
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data?: {
      copied_count: number;
      updated_count: number;
      total_count: number;
    };
  }>(`${server_url}/api/copy_game_records/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 更新用户在比赛中的排行榜显示状态 POST /api/competition/update_participant_leaderboard_status/ */
export async function updateParticipantLeaderboardStatus(
  params: {
    competition_id: number;
    username: string;
    show_in_leaderboard: boolean;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data?: {
      id: number;
      user: {
        id: number;
        username: string;
      };
      competition: {
        id: number;
        name: string;
      };
      show_in_leaderboard: boolean;
      updated_at: string;
    };
  }>(`${server_url}/api/competition/update_participant_leaderboard_status/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

// SSN相关接口

/** 查询SSN记录接口 POST /api/v1/third-party/query-ssn-records/ */
export async function querySsnRecords(params: {
  user_id?: number;
  username?: string;
  ssn_register_id?: string;
  id_card?: string;
  page?: number;
  page_size?: number;
}, options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    data: {
      records: any[];
      pagination: {
        current_page: number;
        page_size: number;
        total_count: number;
        total_pages: number;
        has_next: boolean;
        has_previous: boolean;
      };
    };
    message: string;
  }>(`${server_url}/api/v1/third-party/query-ssn-records/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 解绑SSN用户接口 POST /api/v1/third-party/unbind-ssn-user/ */
export async function unbindSsnUser(params: {
  ssn_register_id?: string;
  user_id?: number;
}, options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    data: {
      unbind_count: number;
      unbind_records: any[];
    };
    message: string;
  }>(`${server_url}/api/v1/third-party/unbind-ssn-user/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 查询活动记录接口 POST /api/v1/third-party/query-activity-records/ */
export async function queryActivityRecords(params: {
  user_id?: number;
  username?: string;
  activity_id?: string;
  id_card?: string;
  ssn_register_id?: string;
  account?: string;
  page?: number;
  page_size?: number;
}, options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    data: {
      records: any[];
      pagination: {
        current_page: number;
        page_size: number;
        total_count: number;
        total_pages: number;
        has_next: boolean;
        has_previous: boolean;
      };
    };
    message: string;
  }>(`${server_url}/api/v1/third-party/query-activity-records/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 解绑活动记录接口 POST /api/v1/third-party/activity-unbind-ssn-user/ */
export async function unbindActivityRecord(params: {
  ssn_register_id?: string;
  activity_register_id?: string;
  user_id?: number;
  activity_type?: number;
}, options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    data: any;
    message: string;
  }>(`${server_url}/api/v1/third-party/activity-unbind-ssn-user/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      activity_type: 1,
      ...params,
    },
    ...(options || {}),
  });
}


/** 重置用户比赛数据接口 POST /api/competition/reset_user_competition_data/ */
export async function resetUserCompetitionData(params: {
  competition_id: number;
  user_id?: number;
  username?: string;
}, options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    data: {
      user: {
        id: number;
        username: string;
      };
      competition: {
        id: number;
        name: string;
      };
      deleted_data: {
        participant_record: boolean;
        progress_count: number;
        cleared_caches: number;
      };
      reset_time: string;
      note: string;
    };
    message: string;
  }>(`${server_url}/api/competition/reset_user_competition_data/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 解锁报名信息接口 POST /api/v1/third-party/unlock-register-info/ */
export async function unlockRegisterInfo(params: {
  register_id: number;
}, options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    data: {
      register_id: number;
      third_party_response: any;
      unlock_time: string;
      notice: string;
    };
    message: string;
  }>(`${server_url}/api/v1/third-party/unlock-register-info/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 获取用户注册时间 POST /api/get_users_registration_time */
export async function getUsersRegistrationTime(params: {
  user_ids: number[];
}, options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    message: string;
    data: Array<{
      user_id: number;
      username: string;
      full_name: string;
      registration_time: string;
      registration_timestamp: number;
      error?: string;
    }>;
  }>(`${server_url}/api/get_users_registration_time/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 撤销用户激活接口 POST /api/revokeUserActivation/ */
export async function revokeUserActivation(
  params: {
    user_id: number;
    permission_type?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data?: {
      revoked_permissions: Array<{
        permission_name: string;
        permission_type: string;
        start_date: string;
        original_end_date: string;
      }>;
      revoked_by: string;
      revoked_at: string;
    };
  }>(`${server_url}/api/revokeUserActivation/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 批量创建学校 POST /api/dealer/batch-create-institutions/ */
export async function batchCreateInstitutions(
  params: {
    institutions: Array<{
      name: string;
      province_name: string;
      city_name: string;
      district_name: string;
    }>;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data: {
      total_requested: number;
      created_count: number;
      updated_count: number;
      skipped_count: number;
      failed_count: number;
      results: Array<{
        name: string;
        status: 'created' | 'updated' | 'skipped' | 'failed';
        message: string;
        institution?: API.InstitutionWithDistrict;
      }>;
    };
  }>(`${server_url}/api/dealer/batch-create-institutions/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 更新学校权重 POST /api/institutions/update-weight/ */
export async function updateInstitutionWeight(
  params: {
    institution_id: number;
    weight: number;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data?: {
      institution: {
        id: number;
        name: string;
        weight: number;
        district: {
          id: number;
          name: string;
          city_id: number;
          city_name: string;
          province_id: number;
          province_name: string;
        };
      };
      cleared_cache_keys: number;
    };
  }>(`${server_url}/api/institutions/update-weight/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 获取学校游戏完成统计 POST /api/get_school_game_completion_stats/ */
export async function getSchoolGameCompletionStats(params: {
  institution_id: number;
  current?: number;
  pageSize?: number;
}, options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    message?: string;
    data: {
      institution_id: number;
      institution_name: string;
      total_students: number;
      summary: {
        total_gamemode_1_completed: number;
        total_gamemode_2_completed: number;
        total_gamemode_3_completed: number;
        students_with_gamemode_1: number;
        students_with_gamemode_2: number;
        students_with_gamemode_3: number;
      };
      students: Array<{
        username: string;
        full_name: string;
        gamemode_1_completed: number;
        gamemode_2_completed: number;
        gamemode_3_completed: number;
      }>;
      pagination: {
        current: number;
        pageSize: number;
        total: number;
      };
    };
  }>(`${server_url}/api/get_school_game_completion_stats/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}


export async function getAuditlogEntries(
  params?: {
    page?: number;
    page_size?: number;
    start_time?: string;
    end_time?: string;
    actor_username?: string;
    object_repr?: string;
    action_text?: string;
    app_label?: string;
    model?: string;
    remote_addr?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success?: boolean;
    message?: string;
    data?: any;
    total?: number;
  }>(`${server_url}/api/getAuditlogEntries/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/** 获取灵丌AI课程体系列表 GET /api/ai-explorer/course-categories/ */
export async function getCourseCategories(
  params?: {
    status?: 'draft' | 'published';
    keyword?: string;
    page?: number;
    page_size?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.CourseCategoryListResult>(`${server_url}/api/ai-explorer/course-categories/`, {
    method: 'GET',
    params: params,
    ...(options || {}),
  });
}

/** 获取课程体系详情 GET /api/ai-explorer/course-categories/{id}/ */
export async function getCourseCategoryDetail(id: number, options?: { [key: string]: any }) {
  return request<API.CourseCategoryItem>(`${server_url}/api/ai-explorer/course-categories/${id}/`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 新建课程体系 POST /api/ai-explorer/course-categories/ */
export async function createCourseCategory(
  data: API.CreateCourseCategoryParams,
  options?: { [key: string]: any },
) {
  return request<API.CourseCategoryItem>(`${server_url}/api/ai-explorer/course-categories/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    ...(options || {}),
  });
}

/** 编辑课程体系 PATCH /api/ai-explorer/course-categories/{id}/ */
export async function updateCourseCategory(
  id: number,
  data: Partial<API.CreateCourseCategoryParams>,
  options?: { [key: string]: any },
) {
  return request<API.CourseCategoryItem>(`${server_url}/api/ai-explorer/course-categories/${id}/`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    ...(options || {}),
  });
}

/** 删除课程体系 DELETE /api/ai-explorer/course-categories/{id}/ */
export async function deleteCourseCategory(id: number, options?: { [key: string]: any }) {
  return request<any>(`${server_url}/api/ai-explorer/course-categories/${id}/`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 获取灵丌AI课程学期列表 GET /api/ai-explorer/course-semesters/ */
export async function getCourseSemesters(
  params?: {
    category?: number;
    status?: 'draft' | 'published';
    keyword?: string;
    page?: number;
    page_size?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.CourseSemesterListResult>(`${server_url}/api/ai-explorer/course-semesters/`, {
    method: 'GET',
    params: params,
    ...(options || {}),
  });
}

/** 拉取全部灵丌AI课程学期（不限发布状态，自动翻页） */
export async function getAllCourseSemesters(
  params?: {
    category?: number;
    status?: 'draft' | 'published';
    keyword?: string;
  },
  options?: { [key: string]: any },
) {
  const pageSize = 100;
  const all: API.CourseSemesterItem[] = [];
  let page = 1;
  let total = 0;
  do {
    const res = await getCourseSemesters(
      { ...params, page, page_size: pageSize },
      options,
    );
    total = res.count || 0;
    all.push(...(res.results || []));
    page += 1;
  } while (all.length < total && page <= 50);
  return all;
}

/** 新建灵丌AI课程学期 POST /api/ai-explorer/course-semesters/ */
export async function createCourseSemester(
  data: API.CreateCourseSemesterParams,
  options?: { [key: string]: any },
) {
  return request<API.CourseSemesterItem>(`${server_url}/api/ai-explorer/course-semesters/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    ...(options || {}),
  });
}

/** 编辑灵丌AI课程学期 PATCH /api/ai-explorer/course-semesters/{id}/ */
export async function updateCourseSemester(
  id: number,
  data: Partial<API.CreateCourseSemesterParams>,
  options?: { [key: string]: any },
) {
  return request<API.CourseSemesterItem>(`${server_url}/api/ai-explorer/course-semesters/${id}/`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    ...(options || {}),
  });
}

/** 删除灵丌AI课程学期 DELETE /api/ai-explorer/course-semesters/{id}/ */
export async function deleteCourseSemester(id: number, options?: { [key: string]: any }) {
  return request<any>(`${server_url}/api/ai-explorer/course-semesters/${id}/`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 获取课件列表 GET /api/ai-explorer/coursewares/ */
export async function getCoursewares(
  params?: {
    semester?: number;
    category?: number;
    status?: 'draft' | 'published';
    format?: string;
    keyword?: string;
    page?: number;
    page_size?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.CoursewareListResult>(`${server_url}/api/ai-explorer/coursewares/`, {
    method: 'GET',
    params: params,
    ...(options || {}),
  });
}

/** 获取课件详情 GET /api/ai-explorer/coursewares/{id}/ */
export async function getCoursewareDetail(id: number, options?: { [key: string]: any }) {
  return request<API.CoursewareItem>(`${server_url}/api/ai-explorer/coursewares/${id}/`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 新建课件 POST /api/ai-explorer/coursewares/ */
export async function createCourseware(
  data: API.CreateCoursewareParams,
  options?: { [key: string]: any },
) {
  return request<API.CoursewareItem>(`${server_url}/api/ai-explorer/coursewares/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    ...(options || {}),
  });
}

/** 编辑课件 PATCH /api/ai-explorer/coursewares/{id}/ */
export async function updateCourseware(
  id: number,
  data: Partial<API.CreateCoursewareParams>,
  options?: { [key: string]: any },
) {
  return request<API.CoursewareItem>(`${server_url}/api/ai-explorer/coursewares/${id}/`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    ...(options || {}),
  });
}

/** 删除课件 DELETE /api/ai-explorer/coursewares/{id}/ */
export async function deleteCourseware(id: number, options?: { [key: string]: any }) {
  return request<any>(`${server_url}/api/ai-explorer/coursewares/${id}/`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 获取分配班级课件列表 GET /api/ai-explorer/class-coursewares/ */
export async function getClassCoursewares(
  params?: {
    class_group?: number;
    courseware?: number;
    is_active?: boolean;
    keyword?: string;
    page?: number;
    page_size?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.ClassCoursewareListResult>(`${server_url}/api/ai-explorer/class-coursewares/`, {
    method: 'GET',
    params: params,
    ...(options || {}),
  });
}

/** 获取分配班级课件详情 GET /api/ai-explorer/class-coursewares/{id}/ */
export async function getClassCoursewareDetail(id: number, options?: { [key: string]: any }) {
  return request<API.ClassCoursewareItem>(`${server_url}/api/ai-explorer/class-coursewares/${id}/`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 分配课件给班级 POST /api/ai-explorer/class-coursewares/ */
export async function assignClassCourseware(
  data: API.AssignClassCoursewareParams,
  options?: { [key: string]: any },
) {
  return request<API.ClassCoursewareItem>(`${server_url}/api/ai-explorer/class-coursewares/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    ...(options || {}),
  });
}

/** 批量分配课件给班级 POST /api/ai-explorer/class-coursewares/ */
export async function assignClassCoursewaresBatch(
  data: API.BatchAssignClassCoursewareParams,
  options?: { [key: string]: any },
) {
  return request<any>(`${server_url}/api/ai-explorer/class-coursewares/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    ...(options || {}),
  });
}

/** 编辑分配班级课件 PATCH /api/ai-explorer/class-coursewares/{id}/ */
export async function updateClassCourseware(
  id: number,
  data: Partial<API.AssignClassCoursewareParams>,
  options?: { [key: string]: any },
) {
  return request<API.ClassCoursewareItem>(`${server_url}/api/ai-explorer/class-coursewares/${id}/`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    ...(options || {}),
  });
}

/** 删除分配班级课件 DELETE /api/ai-explorer/class-coursewares/{id}/ */
export async function deleteClassCourseware(id: number, options?: { [key: string]: any }) {
  return request<any>(`${server_url}/api/ai-explorer/class-coursewares/${id}/`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 获取计价规则列表 GET /api/ai-explorer/points/pricing-rules/ */
export async function getPointsPricingRules(
  params?: {
    page?: number;
    page_size?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.PointsPricingRuleListResult>(`${server_url}/api/ai-explorer/points/pricing-rules/`, {
    method: 'GET',
    params: params,
    ...(options || {}),
  });
}

/** 获取计价规则详情 GET /api/ai-explorer/points/pricing-rules/{id}/ */
export async function getPointsPricingRuleDetail(id: number, options?: { [key: string]: any }) {
  return request<API.PointsPricingRuleItem>(`${server_url}/api/ai-explorer/points/pricing-rules/${id}/`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 新建计价规则 POST /api/ai-explorer/points/pricing-rules/ */
export async function createPointsPricingRule(
  data: API.CreatePointsPricingRuleParams,
  options?: { [key: string]: any },
) {
  return request<API.PointsPricingRuleItem>(`${server_url}/api/ai-explorer/points/pricing-rules/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    ...(options || {}),
  });
}

/** 全量更新计价规则 PUT /api/ai-explorer/points/pricing-rules/{id}/ */
export async function updatePointsPricingRule(
  id: number,
  data: API.CreatePointsPricingRuleParams,
  options?: { [key: string]: any },
) {
  return request<API.PointsPricingRuleItem>(`${server_url}/api/ai-explorer/points/pricing-rules/${id}/`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    ...(options || {}),
  });
}

/** 局部更新计价规则 PATCH /api/ai-explorer/points/pricing-rules/{id}/ */
export async function patchPointsPricingRule(
  id: number,
  data: Partial<API.CreatePointsPricingRuleParams>,
  options?: { [key: string]: any },
) {
  return request<API.PointsPricingRuleItem>(`${server_url}/api/ai-explorer/points/pricing-rules/${id}/`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    ...(options || {}),
  });
}

/** 删除计价规则 DELETE /api/ai-explorer/points/pricing-rules/{id}/ */
export async function deletePointsPricingRule(id: number, options?: { [key: string]: any }) {
  return request<any>(`${server_url}/api/ai-explorer/points/pricing-rules/${id}/`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 初始化默认规则 POST /api/ai-explorer/points/pricing-rules/seed-defaults/ */
export async function seedPointsPricingRules(options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    message: string;
  }>(`${server_url}/api/ai-explorer/points/pricing-rules/seed-defaults/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {},
    ...(options || {}),
  });
}

const POINTS_PRICE_SETTINGS_URL = `${server_url}/api/ai-explorer/points/price-settings/`;

/** 获取积分包列表 GET /api/ai-explorer/points/price-settings/ */
export async function getPointsPriceSettings(
  params?: {
    page?: number;
    page_size?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.PointsPriceSettingListResult>(POINTS_PRICE_SETTINGS_URL, {
    method: 'GET',
    params: params,
    ...(options || {}),
  });
}

/** 新建积分包 POST /api/ai-explorer/points/price-settings/ */
export async function createPointsPriceSetting(
  data: API.CreatePointsPriceSettingParams,
  options?: { [key: string]: any },
) {
  return request<API.PointsPriceSettingItem>(POINTS_PRICE_SETTINGS_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    ...(options || {}),
  });
}

/** 局部更新积分包 PATCH /api/ai-explorer/points/price-settings/{id}/ */
export async function patchPointsPriceSetting(
  id: number,
  data: Partial<API.CreatePointsPriceSettingParams>,
  options?: { [key: string]: any },
) {
  return request<API.PointsPriceSettingItem>(`${POINTS_PRICE_SETTINGS_URL}${id}/`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    ...(options || {}),
  });
}

/** 删除积分包 DELETE /api/ai-explorer/points/price-settings/{id}/ */
export async function deletePointsPriceSetting(id: number, options?: { [key: string]: any }) {
  return request<any>(`${POINTS_PRICE_SETTINGS_URL}${id}/`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

const MEMBERSHIP_PRICE_SETTINGS_URL = `${server_url}/api/membership-payment/price-settings/`;

/** 灵丌编程会员价格设置列表 GET /api/membership-payment/price-settings/ */
export async function getMembershipPriceSettings(
  params?: {
    page?: number;
    page_size?: number;
    search?: string;
    listing_status?: 'on' | 'off' | string;
  },
  options?: { [key: string]: any },
) {
  return request<API.MembershipPriceSettingListResult>(MEMBERSHIP_PRICE_SETTINGS_URL, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 更新会员价格 PATCH /api/membership-payment/price-settings/{id}/ （仅 price / listing_status） */
export async function patchMembershipPriceSetting(
  id: number,
  data: { price?: number; listing_status?: 'on' | 'off' | string },
  options?: { [key: string]: any },
) {
  return request<API.MembershipPriceSettingItem>(`${MEMBERSHIP_PRICE_SETTINGS_URL}${id}/`, {
    method: 'PATCH',
    data,
    ...(options || {}),
  });
}

/** 获取灵丌AI积分流水列表 GET /api/ai-explorer/points/transactions/ */
export async function getPointsTransactions(
  params?: {
    page?: number;
    page_size?: number;
    username?: string;
    user_id?: number;
    biz_type?: string;
    direction?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.PointsTransactionListResult>(`${server_url}/api/ai-explorer/points/transactions/`, {
    method: 'GET',
    params: params,
    ...(options || {}),
  });
}

/** 获取灵丌AI积分流水详情 GET /api/ai-explorer/points/transactions/{id}/ */
export async function getPointsTransactionDetail(id: number, options?: { [key: string]: any }) {
  return request<API.PointsTransactionItem>(`${server_url}/api/ai-explorer/points/transactions/${id}/`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取系统角色列表 GET /api/ai-explorer/system-roles/ */
export async function getSystemRoles(
  params?: {
    keyword?: string;
    is_active?: boolean | string;
    page?: number;
    page_size?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.AiSystemRoleListResult>(`${server_url}/api/ai-explorer/system-roles/`, {
    method: 'GET',
    params: params,
    ...(options || {}),
  });
}

/** 获取系统角色详情 GET /api/ai-explorer/system-roles/{id}/ */
export async function getSystemRoleDetail(id: number, options?: { [key: string]: any }) {
  return request<API.AiSystemRoleItem>(`${server_url}/api/ai-explorer/system-roles/${id}/`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 新建系统角色 POST /api/ai-explorer/system-roles/ */
export async function createSystemRole(
  data: API.CreateAiSystemRoleParams,
  options?: { [key: string]: any },
) {
  return request<API.AiSystemRoleItem>(`${server_url}/api/ai-explorer/system-roles/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    ...(options || {}),
  });
}

/** 编辑系统角色 PATCH /api/ai-explorer/system-roles/{id}/ */
export async function updateSystemRole(
  id: number,
  data: Partial<API.CreateAiSystemRoleParams>,
  options?: { [key: string]: any },
) {
  return request<API.AiSystemRoleItem>(`${server_url}/api/ai-explorer/system-roles/${id}/`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    ...(options || {}),
  });
}

/** 删除系统角色 DELETE /api/ai-explorer/system-roles/{id}/ */
export async function deleteSystemRole(id: number, options?: { [key: string]: any }) {
  return request<any>(`${server_url}/api/ai-explorer/system-roles/${id}/`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 后台灵丌AI作品审核列表 POST /api/ai-explorer/works/admin/list/ */
export async function getAiWorkReviewList(
  data?: {
    page?: number;
    page_size?: number;
    work_type?: string;
    is_public?: number | 'all';
    keyword?: string;
    username?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AiWorkReviewListResult>(`${server_url}/api/ai-explorer/works/admin/list/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data || {},
    ...(options || {}),
  });
}

/** 后台灵丌AI作品审核通过 POST /api/ai-explorer/works/admin/approve/ */
export async function approveAiWork(
  data: { id: number },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data?: { id: number; is_public: number };
  }>(`${server_url}/api/ai-explorer/works/admin/approve/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/** 后台切换作品公开状态 POST /api/ai-explorer/works/admin/set-public/ */
export async function setAiWorkPublic(
  data: { id: number; is_public: 1 | 2 },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data?: { id: number; is_public: number };
  }>(`${server_url}/api/ai-explorer/works/admin/set-public/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/** 生成AI课程激活码 POST /api/ai-explorer/generate-course-activation-codes/ */
export async function generateCourseActivationCodes(
  data: {
    count: number;
    semester_id: number;
    duration_days?: number;
    remark?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.GenerateCourseActivationCodesResult>(
    `${server_url}/api/ai-explorer/generate-course-activation-codes/`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
      ...(options || {}),
    },
  );
}

/** 查询AI课程激活码 POST /api/ai-explorer/get-course-activation-codes/ */
export async function getCourseActivationCodes(
  data?: {
    current?: number;
    pageSize?: number;
    semester_id?: number;
    searchText?: string;
    filters?: { is_redeemed?: boolean };
  },
  options?: { [key: string]: any },
) {
  return request<API.CourseActivationCodeListResult>(
    `${server_url}/api/ai-explorer/get-course-activation-codes/`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: data || {},
      ...(options || {}),
    },
  );
}

/** 灵丌AI订单退款：回滚已开通业务，不调用微信退款 POST /api/ai-explorer/admin/payment-orders/{id}/refund/ */
export async function refundAiPaymentOrder(
  id: number,
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; message?: string; errorMessage?: string }>(
    `${server_url}/api/ai-explorer/admin/payment-orders/${id}/refund/`,
    {
      method: 'POST',
      ...(options || {}),
    },
  );
}

/** 灵丌AI订单列表与统计 GET /api/ai-explorer/admin/payment-orders/ */
export async function getAiPaymentOrders(
  params?: {
    page?: number;
    page_size?: number;
    username?: string;
    user_id?: number;
    out_trade_no?: string;
    status?: string;
    product_type?: string;
    channel?: string;
    start_date?: string;
    end_date?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AiPaymentOrderListResult>(
    `${server_url}/api/ai-explorer/admin/payment-orders/`,
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

/** 后台开通/续期用户课程体系权限 POST /api/ai-explorer/activate-user-course-permission/ */
export async function activateUserCoursePermission(
  data: {
    user_id?: number;
    user_ids?: number[];
    semester_id?: number;
    semester_ids?: number[];
    duration_days: number | null;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    message: string;
    data?: {
      semester?: {
        id: number;
        name: string;
        category_id?: number;
        start_date?: string;
        end_date?: string | null;
      } | null;
      semesters?: Array<{
        id: number;
        name: string;
        category_id?: number;
        start_date?: string;
        end_date?: string | null;
      }>;
    };
  }>(`${server_url}/api/ai-explorer/activate-user-course-permission/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/** 赛事活动列表 GET /api/competition-activities/ */
export async function getCompetitionActivities(
  params?: { is_visible?: boolean | string },
  options?: { [key: string]: any },
) {
  return request<API.CompetitionActivityListResult>(`${server_url}/api/competition-activities/`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 添加赛事活动 POST /api/competition-activities/ */
export async function createCompetitionActivity(
  data: API.CompetitionActivityPayload,
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; message?: string; data?: API.CompetitionActivityItem }>(
    `${server_url}/api/competition-activities/`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data,
      ...(options || {}),
    },
  );
}

/** 修改赛事活动 POST /api/competition-activities/{id}/update/ */
export async function updateCompetitionActivity(
  id: number,
  data: Partial<API.CompetitionActivityPayload>,
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; message?: string; data?: API.CompetitionActivityItem }>(
    `${server_url}/api/competition-activities/${id}/update/`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data,
      ...(options || {}),
    },
  );
}

/** 删除赛事活动 POST /api/competition-activities/{id}/delete/ */
export async function deleteCompetitionActivity(
  id: number,
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; message?: string }>(
    `${server_url}/api/competition-activities/${id}/delete/`,
    {
      method: 'POST',
      ...(options || {}),
    },
  );
}

/** 班级AI提示词列表 POST /api/ai-explorer/class-prompts/list/ */
export async function getClassAiPrompts(
  data: { class_id: number; prompt_type?: string },
  options?: { [key: string]: any },
) {
  return request<API.ClassAiPromptListResult>(`${server_url}/api/ai-explorer/class-prompts/list/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data,
    ...(options || {}),
  });
}

/** 添加班级AI提示词 POST /api/ai-explorer/class-prompts/create/ */
export async function createClassAiPrompt(
  data: { class_id: number; title: string; content: string; prompt_type: string },
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; message?: string; data?: API.ClassAiPromptItem }>(
    `${server_url}/api/ai-explorer/class-prompts/create/`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data,
      ...(options || {}),
    },
  );
}

/** 修改班级AI提示词 POST /api/ai-explorer/class-prompts/update/ */
export async function updateClassAiPrompt(
  data: { id: number; title: string; content: string; prompt_type: string },
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; message?: string; data?: API.ClassAiPromptItem }>(
    `${server_url}/api/ai-explorer/class-prompts/update/`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data,
      ...(options || {}),
    },
  );
}

/** 删除班级AI提示词 POST /api/ai-explorer/class-prompts/delete/ */
export async function deleteClassAiPrompt(
  data: { id: number },
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; message?: string }>(
    `${server_url}/api/ai-explorer/class-prompts/delete/`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data,
      ...(options || {}),
    },
  );
}




